import React from 'react'
import moment from 'moment'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useTranslation } from 'react-i18next'
import { apiFormat, format } from '@cbgms/base/utils/datetime'
import { AppointmentsChartOptions } from '../ChartOptions/AppointmentsChartOptions'
import { StatisticsAppointments } from '@cbgms/api/modules/statistics'

const MonitorAppointmentsChart: React.FC<{ data: StatisticsAppointments[] }> = props => {
  const { t } = useTranslation()

  const appointmentsData = props.data.map(row => {
    return {
      name: moment(row.StartDate, apiFormat.yearMonthDay).format(format.monthLong),
      y: row.TotalAppointments
    }
  })

  const motData = props.data.map(row => {
    return {
      name: moment(row.StartDate, apiFormat.yearMonthDay).format(format.monthLong),
      y: row.TotalMOT
    }
  })

  const tyrechangeData = props.data.map(row => {
    return {
      name: moment(row.StartDate, apiFormat.yearMonthDay).format(format.monthLong),
      y: row.TotalTyreChange
    }
  })

  const options = AppointmentsChartOptions(appointmentsData, motData, tyrechangeData, '45%', false)

  if (options.series) {
    options.series[0].name = t('global.stats.appointments')
  }

  if (options.series) {
    options.series[1].name = t('global.stats.mot')
  }

  if (options.series) {
    options.series[2].name = t('global.stats.tyre_change')
  }

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default MonitorAppointmentsChart
